module.exports = __webpack_public_path__ + "img/share-screen.7683fab5.svg";